import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
  Button,
  Stack,
  ListItem,
  ListItemIcon,
  Divider,
  Icon,
} from "@mui/material";
import {
  SpaceDashboard,
  Email,
  Settings,
  TripOriginRounded,
  Brightness1Rounded,
} from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import minifiedlogo from "../minifiedlogo.png";
import logo from "../logo.png";
const Sidebar = ({ collapsed }) => {
  const location = useLocation();

  const navItems = [
    { text: "Dashboard", icon: <SpaceDashboard color="primary" />, path: "/" },
    {
      text: "Email Template",
      icon: <Email color="primary" />,
      path: "/emailtemplates",
    },
  ];
  const themeStatus = [
    {
      label: "Live on storefront",
      icon: <Brightness1Rounded sx={{ color: "#4E8B6E" }} />,
    },
    {
      label: "Trial theme",
      icon: <Brightness1Rounded sx={{ color: "#E7B11C" }} />,
    },
    {
      label: "Unpublished",
      icon: <Brightness1Rounded sx={{ color: "#516ECB" }} />,
    },
    {
      label: "Zip uploaded from outside",
      icon: <Brightness1Rounded sx={{ color: "#CF4C44" }} />,
    }
  ];
  const bottomMenu = [
    { text: "Settings", icon: <Settings />, path: "/settings" },
  ];
  return (
    <Drawer
      className="sidebar"
      variant="permanent"
      sx={{
        width: collapsed ? 70 : 265,
        [`& .MuiDrawer-paper`]: {
          width: collapsed ? 70 : 265,
          boxSizing: "border-box",
          transition: "width 0.2s ease",
        },
      }}
    >
      <div className="logo-wrapper">
        <a href="#" className="logo-wrapper-image">
          <img src={collapsed ? minifiedlogo : logo} alt="logo" />
        </a>
      </div>
      <List className="sidebar-navItems" sx={{ px: 2, py: 2 }}>
        {navItems.map((item) => (
          <ListItemButton
            className="sidebar-navItems-button"
            key={item.text}
            component={Link}
            to={item.path}
            selected={location.pathname === item.path}
            sx={{
              fontSize: "12px",
              marginBlockEnd: "5px",
              justifyContent: collapsed ? "center" : "flex-start",
              backgroundColor:
                location.pathname === item.path
                  ? "rgba(30, 188, 143, 0.08)"
                  : "transparent",
            }}
          >
            <ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 0 : 0.7 }}>
              {item.icon}
            </ListItemIcon>
            {!collapsed && <ListItemText  primary={item.text}  />}
          </ListItemButton>
        ))}
      </List>
      <Stack className="sidebar-bottom" direction={"column"} spacing={1}>
        <Box >
          <Box
            sx={{
              borderRadius: 2,
              bgcolor: "#F6F6F6",
              padding: 2,
              fontSize: "12px"
              
            }}
          >
            {/* Status items */}
            {themeStatus.map((status) => (
              <Stack
                className="sidebar-bottom-menu"
                key={status.label}
                direction="row"
              >
                <Icon sx={{ minWidth: 0, mr: collapsed ? 0 : 2 }}>
                  {status.icon}
                </Icon>
                {!collapsed && (
                  <Typography sx={{
                    fontWeight: 'medium'
                  }}
                  fontSize={"12px"}>{status.label} </Typography>
                )}
              </Stack>
            ))}
          </Box>
        </Box>

        <List disablePadding >
          {bottomMenu.map((item) => (
            <ListItemButton
              key={item.text}
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              sx={{
                justifyContent: collapsed ? "center" : "flex-start",
                backgroundColor: "#F6F6F6"
              }}
            >
              <ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 0 : 0.7 }}>
                {item.icon}
              </ListItemIcon>
              {!collapsed && <ListItemText primary={item.text} />}
            </ListItemButton>
          ))}
        </List>
      </Stack>
    </Drawer>
  );
};

export default Sidebar;
